import { Button } from "antd";

export default function Revision() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FDEBDE", backgroundColor: "#FDEBDE80" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/revision.svg" alt="" />
        <Button
          htmlType="button"
          className="orange-btn btn-sm"
          type="primary"
          style={{ backgroundColor: "#F06400" }}
        >
          View request
        </Button>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#F06400", fontWeight: "700" }}>
          Revision requested
        </span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        Client asked for revision.
      </h6>
    </div>
  );
}
